import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=955f5e4a&scoped=true"
import script from "./ContentLayout.vue?vue&type=script&lang=js"
export * from "./ContentLayout.vue?vue&type=script&lang=js"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=955f5e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f5e4a",
  null
  
)

export default component.exports